.border {
  padding: 10px 19px 19px;
}
